import React, { useContext, useMemo } from "react";
import { BookingContext } from "../Context";
import { IntlContext } from "context";
import moment from "moment/moment";

const OurServicesInfoService: React.FC = () => {
    const intl = useContext(IntlContext);
    const { getBooking } = useContext(BookingContext);
    const bookingData = useMemo(() => {
        return getBooking();
    }, [getBooking]);

    return (
        <div className="our_services">
            <h3 className="flex flex--align-items-center flex--justify-content-space-between flex--wrap">
                <span>
                    {intl.formatMessage("our_services.form.label.additional_information.begin_title")}
                    <span className={"text-color--" + bookingData?.category.toString().toLocaleLowerCase()}>{bookingData?.subcategory ? intl.formatMessage(`service.label.subcategory.${bookingData?.subcategory}`) : intl.formatMessage(`service.label.category.${bookingData?.category}`)}</span>
                    {intl.formatMessage(`our_services.form.label.additional_information.date_time_title`, {
                        date: moment(bookingData?.date).format("D MMMM YYYY"),
                        time: moment(bookingData?.start_time, "HH:mm:ss").format("HH:mm"),
                    })}
                    {intl.formatMessage(`our_services.form.label.additional_information.duration_time_title`, {
                        duration: bookingData?.nb_hours,
                    })}
                </span>
                <span className="bold text-color--primary padding-y--1">{Number(bookingData?.amount).toFixed(2)} €</span>
            </h3>
        </div>
    );
};

export default OurServicesInfoService;
